/**
 * * Тип элемента в дереве
 */
export enum TreeItemType {
  /**Проект */
  Project = "project",
  /**Рабочая область */
  Namespace = "namespace",
  /**Группа */
  Group = "group",
  /**Очередь */
  Queue = "queue",
}
